import { Alert, Button, HFlow, Icon, Text, useStyles, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { CidadaoListingQuery } from 'graphql/types.generated'
import { useRouter } from 'hooks/useRouter'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import Permissions from 'types/Permissions'

import { JustificativaModal } from '../JustificativaModal'
import { CidadaoUrlParams } from '../types/CidadaoUrlParams'
import { CidadaoCadsusListingItem } from './CidadaoCadsusListItem'
import { CidadaoListingItem } from './CidadaoListingItem'
import { CidadaoCadsusItemType } from './CidadaoListView'

interface CidadaoListingViewProps {
  result: CidadaoListingQuery
  resultCadsus: CidadaoCadsusItemType[]
  loadingCadsus: boolean
  hasCadsusCalled: boolean
  onBuscarClicked(): void
  refetchLocal(): void
  hasInternetConnection: boolean
  hasCadsusConnection: boolean
  cidadaoUrlParams: CidadaoUrlParams
}

export function CidadaoListItemView(props: CidadaoListingViewProps) {
  const { result, resultCadsus, hasInternetConnection, hasCadsusConnection } = props
  const { match } = useRouter()
  const history = useHistory()
  const totalElements = props.result?.cidadaos?.pageInfo.numberOfElements
  const totalElementsCadsus = props.resultCadsus?.length
  const hasMoreResults = props.result?.cidadaos?.pageInfo.totalElements > 50
  const isOnline = props.hasInternetConnection && props.hasCadsusConnection
  const { theme } = useStyles()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [cidadaoJustificativaId, setCidadaoJustificativaId] = useState<string>()

  const onClickAdicionarCidadao = () => {
    history.push(`${match.url}/create${history.location.search}`)
  }

  return (
    <>
      <JustificativaModal
        cidadaoId={cidadaoJustificativaId}
        isModalOpen={isModalOpen}
        handleModalClose={() => setIsModalOpen(false)}
      />
      {result != null ? (
        <VFlow vSpacing={0.5}>
          <HFlow alignItems='baseline'>
            <Text fontWeight='bold' fontSize={1.5}>
              Cadastros na base local
            </Text>
            {totalElements > 0 && !hasMoreResults ? (
              <Text fontSize={1}>
                {totalElements === 1 ? totalElements + ' cidadão encontrado' : totalElements + ' cidadãos encontrados'}
              </Text>
            ) : null}
          </HFlow>
          {totalElements > 0 &&
            !hasMoreResults &&
            result.cidadaos?.content?.map((result) => (
              <CidadaoListingItem
                data={result}
                key={result.id}
                refetchLocal={props.refetchLocal}
                cidadaoUrlParams={props.cidadaoUrlParams}
                handleCidadaoIdJustificativa={(id: string) => setCidadaoJustificativaId(id)}
                setIsModalJustificativaOpen={() => setIsModalOpen(true)}
              />
            ))}
          {!totalElements && !hasMoreResults && <Text>Nenhum resultado encontrado.</Text>}
          {hasMoreResults && <Text>Refine a busca incluindo mais informações.</Text>}

          <HFlow alignItems='baseline' style={{ marginTop: '1rem' }}>
            <Text fontWeight='bold' fontSize={1.5}>
              Cadastros na base nacional
            </Text>

            {totalElementsCadsus > 0 ? (
              <Text fontSize={1}>
                {totalElementsCadsus === 1
                  ? totalElementsCadsus + ' cidadão encontrado'
                  : totalElementsCadsus + ' cidadãos encontrados'}
              </Text>
            ) : null}
          </HFlow>

          {!hasInternetConnection ? (
            <Alert inline type='warning'>
              Não foi possível buscar na base nacional, pois a instalação está offline. Entre em contato com o
              responsável pela instalação para mais informações.
            </Alert>
          ) : (
            !hasCadsusConnection && (
              <Alert inline type='warning'>
                Não foi possível buscar na base nacional, pois a conexão com o serviço está desabilitada. Entre em
                contato com o responsável pela instalação para mais informações.
              </Alert>
            )
          )}

          {isOnline && props.result && !props.resultCadsus && (
            <Button size='large' block loading={props.loadingCadsus} onClick={props.onBuscarClicked}>
              <Icon icon='zoomOutline' style={{ marginRight: '0.5rem' }} />
              Pesquisar na base nacional
            </Button>
          )}
          {props.resultCadsus?.map((result) => (
            <CidadaoCadsusListingItem data={result} key={result.cns} />
          ))}
          {resultCadsus != null && !resultCadsus?.length && <Text>Nenhum resultado encontrado.</Text>}
          <CheckPermission permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao.cadastrarEEditar}>
            {props.result != null && (
              <>
                <div
                  style={{ borderTop: `1px solid ${theme.pallete.divider}`, marginTop: '1.6rem', marginBottom: '1rem' }}
                />
                <HFlow justifyContent='flex-end'>
                  <Button kind='primary' skin='default' size='medium' onClick={onClickAdicionarCidadao}>
                    Adicionar cidadão
                  </Button>
                </HFlow>
              </>
            )}
          </CheckPermission>
        </VFlow>
      ) : (
        <VFlow style={{ marginTop: '1rem' }}>
          <Text fontWeight='bold' fontSize={1}>
            Busque um cidadão pelo seu nome, CPF, CNS ou demais informações.
          </Text>
        </VFlow>
      )}
    </>
  )
}
